export default __webpack_public_path__ + "static/media/case-V60.31d19b56.jpg";